
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","height":"24","width":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('title',[_v('database-search')]),_c('path',{attrs:{"d":"M9.767,9.662C4.624,9.248.75,7.43.75,5.251.75,2.765,5.787.751,12,.751s11.25,2.014,11.25,4.5c0,1.181-1.138,2.256-3,3.059","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('line',{attrs:{"x1":"23.25","y1":"11.251","x2":"23.25","y2":"5.251","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('path',{attrs:{"d":"M.75,5.251v6c0,1.85,2.792,3.439,6.782,4.131","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('path',{attrs:{"d":"M.75,11.251v6c0,2.179,3.874,4,9.017,4.411","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('circle',{attrs:{"cx":"15.75","cy":"15.751","r":"5.25","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('line',{attrs:{"x1":"23.25","y1":"23.251","x2":"19.462","y2":"19.463","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}})])
          )
        }
      }
    